<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <v-select
          v-model="day"
          :disabled="readonly"
          :error-messages="errors"
          :items="days"
          :label="label ? label + ' (Gün)' : 'Gün'"
          :outlined="outlined"
          :required="required"
          :rules="[(v) => !!v || 'Doğum tarihi alanı boş bırakılamaz']"
          hide-details
          @change="save"
        />
      </v-col>

      <v-col>
        <v-select
          v-model="month"
          :disabled="readonly"
          :error-messages="errors"
          :items="months"
          :label="label ? label + ' (Ay)' : 'Ay'"
          :outlined="outlined"
          :required="required"
          :rules="[(v) => !!v || 'Doğum tarihi alanı boş bırakılamaz']"
          class="ml-1"
          hide-details
          @change="save"
        />
      </v-col>

      <v-col>
        <v-select
          v-model="year"
          :disabled="readonly"
          :error-messages="errors"
          :items="years"
          :label="label ? label + ' (Yıl)' : 'Yıl'"
          :outlined="outlined"
          :required="required"
          :rules="[(v) => !!v || 'Doğum tarihi alanı boş bırakılamaz']"
          class="ml-1"
          hide-details
          @change="save"
        />
      </v-col>
    </v-row>
    <div v-if="errors" class="text-danger mt-1">
      {{ errors }}
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    isValidForm: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    selectedToday: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    dateRestriction: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      day: null,
      month: null,
      year: null,
      errors: null,
    };
  },
  created() {
    if (this.selectedToday) {
      const today = new Date().toISOString().slice(0, 10);
      this.day = today.slice(8, 10);
      this.month = today.slice(5, 7);
      this.year = today.slice(0, 4);
      this.$emit("input", today);
    }

    if (this.value) {
      const [year, month, day] = this.value.split("-");
      this.day = day;
      this.month = month;
      this.year = year;
    }
  },
  methods: {
    save() {
      if (!this.day || !this.month || !this.year) return;
      // this.$refs.menu.save(this.selectedDate);

      const date = moment(
        `${this.year}-${this.month}-${this.day}`,
        "YYYY-MM-DD"
      );

      if (date.isBefore(moment()) && this.dateRestriction === "before") {
        this.errors = "Bugünden önceki bir tarih giremezsiniz!";
        return;
      }

      if (date.isAfter(moment()) && this.dateRestriction === "after") {
        this.errors = "Bugünden sonraki bir tarih giremezsiniz!";
        return;
      }

      if (date.isValid()) {
        this.$emit("input", `${this.year}-${this.month}-${this.day}`);
        this.errors = null;
        this.isValidForm = true;
        return;
      }

      this.errors = "Geçersiz bir tarih girdiniz!";
    },
  },
  computed: {
    days() {
      return Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, 0)
      ).map((d) => d.toString());
    },
    months() {
      return Array.from({ length: 12 }, (_, i) =>
        String(i + 1).padStart(2, 0)
      ).map((m) => m.toString());
    },
    years() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 100 }, (_, i) => currentYear - i).map((y) =>
        y.toString()
      );
    },
    formattedDate() {
      return `${this.year}-${this.month}-${this.day}`;
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        const [year, month, day] = newVal.split("-");
        this.day = day;
        this.month = month;
        this.year = year;
      }
    },
    formattedDate(val) {
      this.$emit("input", val);
    },
  },
};
</script>
